import React, { useState, useEffect } from "react";
import DeleteModal from "./Assets/DeleteModal";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from "react-toastify";

const Roles = ({ isSidebarCollapsed }) => {
  const [Roles, setRoles] = useState([]);
  const [Heads, setHeads] = useState([]); 
  const [submitState, setSubmitState] = useState(false); 

  const [formData, setFormData] = useState({
    name: ""
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [changeColour, setChangeColour] = useState(null);
  const [deptId, setDeptId] = useState(null);
  const Auth = localStorage.getItem("authToken");


  useEffect(() => {
    fetchRoles();
  }, []);

  
  const fetchRoles = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/roles_management/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch data");

      const result = await response.json();
      

      
      
      setRoles(result.data);
      
      setLoading(false);
    } catch (err) {
      //console.error("Error fetching roles:", err);
      setError(err.message);
      setLoading(false);
    }
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitState(true);

    try {
      let response;
      if (editId) {
        response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/roles_management/edit/${editId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Auth}`,
          },
          body: JSON.stringify(formData),
        });
      } else {
        response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/roles_management/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Auth}`,
          },
          body: JSON.stringify(formData),
        });
        

      }

      const errorText = await response.json();

      
      if (response.status === 440) {
        toast.warning(errorText.message || "Session expired or custom warning!");
      } else if (!errorText.success) {
        toast.error(errorText.message || "Failed to save designation");
      } else {
        toast.success(errorText.message || "Designation saved successfully!");
      }
      setSubmitState(false);

      await fetchRoles();
      setFormData({ name: "", department_id: "", reporting_id: "" });
      
      setEditId(null);
    } catch (error) {
      //console.error("Error saving designation:", error);
    }
  };

  const handleEdit = (id) => {
    const roleToEdit = Roles.find((p) => p.id === id);
    if (roleToEdit) {
      setFormData({
        name: roleToEdit.name,
      });
      setEditId(id);

      
    }
  };

  const cancelEdit = () => {
    setFormData({ name: ""});
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/roles_management/delete/${itemToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }
      });
      const errorText = await response.json();
      
      if (!response.ok) {
        toast.error(errorText.message || "Failed to delete Designation");
      } else {
        toast.success(errorText.message || "Designation deleted successfully");
      }
    } catch (error) {
      //console.error("Error deleting user:", error);
    }
    fetchRoles();
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };
  const getRoleName = (id) => {
    const role = Roles.find((r) => r.id === id);
    return role ? role.name : `Role ID: ${id}`;
  };

  if (loading) return <h2 className="text-left">Loading...</h2>;

  return (
    <div className="role-settings-container">
      <div className="bg-white p-[1vw] role-settings-form-container">
        <div className="text-[20px] font-bold border-b-1 text-gray-600 border-gray-300 pb-[2px]">
          <h1 className="text-gray-600">
            {editId ? "Update Designation" : "Add Designation"}
          </h1>
        </div>

        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Designation Name *
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Role Name"
              className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
              required
            />
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              disabled={submitState}
            >
              {editId ? (submitState ? "Updating..." : "Update")  : (submitState ? "Saving..." : "Save")}
            </button>
            {editId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="flex justify-between flex-wrap">
            <h1 className="text-[20px] font-bold pb-[10px]">Designation List </h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">#</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Designation</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-center">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Roles.filter((role) => !deptId || role.department_id === deptId).length > 0 ? (
                      Roles.filter((role) => !deptId || role.department_id === deptId)
                        .map((role, index) => (
                          <tr className="grid grid-cols-5" key={role.id}>
                            <td className="px-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left font-medium text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {index+1}
                              </div>
                            </td>

                            <td className="pr-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {role.name || "N/A"}
                              </div>
                            </td>
                            

                            
                            <td className="px-4 py-2 whitespace-nowrap">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(role.id)}
                                  className={`text-blue-500 hover:text-blue-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(role.id)}
                                  className={`text-red-500 hover:text-red-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>

                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="p-2 text-center">
                            No Designation Details added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
        
      </ul>

      
      {deleteModalShow && (
        <DeleteModal
          itemName={Roles.find((p) => p.id === itemToDelete)?.name || "Role"}
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Roles;